import { useState } from "react";
import { ProgramItems } from "types/landing";

export const useDisableOrderButton = ({
  onBuy,
  onRegister
}: {
  onBuy?: (val: ProgramItems) => void;
  onRegister?: (num: number, value?: ProgramItems) => void;
}) => {
  const [isOrderButtonDisable, setIsOrderButtonDisable] = useState(false);

  const handleDisable = (callback: () => void) => {
    if (isOrderButtonDisable) return;
    setIsOrderButtonDisable(true);
    callback();
    setTimeout(() => setIsOrderButtonDisable(false), 3000);
  };

  const onBuyOrder = (value: ProgramItems) => {
    if (onBuy) {
      handleDisable(() => onBuy(value));
    }
  };

  const onRegisterOrder = (num: number, value?: ProgramItems) => {
    if (onRegister) {
      handleDisable(() => onRegister(num, value));
    }
  };

  return { isOrderButtonDisable, onBuyOrder, onRegisterOrder };
};
